import {inject, Injectable}                                                                                                                   from '@angular/core';
import {CrudRecordType, CrudRecordTypes, GlobalDataTypesDict, HkitRecordLogType, HkitRecordLogTypes, PointWithData, RizeSessionType, Session} from '@djsharkk/logr-types';
import {ChartDataset}                                                                                                                         from 'chart.js';
import {DateTime}                                                                                                                             from 'luxon';
import {UiThemeService}                                                                                                                       from '../../logr-ui/utils/ui-theme.service';
import {ChartPropsService}                                                                                                                    from './chart-props.service';

@Injectable({
				providedIn: 'root'
			})
export class ChartDefaultsService {

	private svcUiTheme = inject(UiThemeService)
	private svcChartProps = inject(ChartPropsService);

	rizeDatasetsDoughnut(): ChartDataset<"doughnut", number[]>[] {
		return [
			{
				label          : 'Duration',
				data           : [
					0,
					0,
					0,
					0,
					0,
					0
				],
				backgroundColor: [
					this.svcChartProps.stripeAnnotationStylesWeekdays.workout,
					GlobalDataTypesDict.time_in_daylight.colorHex || this.svcUiTheme.getTailwindColor(GlobalDataTypesDict.time_in_daylight.colorTw, 900, 0.25),
					this.svcUiTheme.getTailwindColor('green', 900, 0.25),
					this.svcUiTheme.getTailwindColor(this.svcChartProps.rizeColors.focus, 900, 0.25),
					this.svcChartProps.rizePatternsDark.meeting,
					this.svcUiTheme.getTailwindColor('neutral', 900, 0.25)
				],
				borderColor    : [
					'transparent',
					GlobalDataTypesDict.time_in_daylight.colorHex || this.svcUiTheme.getTailwindColor(GlobalDataTypesDict.time_in_daylight.colorTw, 600),
					this.svcUiTheme.getTailwindColor('green', 600),
					this.svcUiTheme.getTailwindColor(this.svcChartProps.rizeColors.focus, 600),
					'transparent',
					'transparent'
				],
				borderWidth    : [
					0,
					1,
					1,
					1,
					0,
					0
				],
				borderAlign    : 'inner'
			}
		]
	}

	rizeDatasetsLine(dark = false): ChartDataset<"line" | "scatter", PointWithData[]>[] {
		return [
			{
				label      : 'Focus',
				type       : 'line',
				data       : [],
				borderColor: this.svcUiTheme.getTailwindColor(this.svcChartProps.rizeColors.focus, dark ? 900 : 700, 0.5),
				borderWidth: 6,
				pointRadius: 0
			},
			{
				label      : 'Break',
				type       : 'line',
				data       : [],
				borderColor: this.svcUiTheme.getTailwindColor('neutral', dark ? 900 : 700),
				borderWidth: 2,
				pointRadius: 0
			},
			{
				label      : 'Meeting',
				type       : 'line',
				data       : [],
				borderColor: this.svcChartProps[dark ? 'rizePatternsDark' : 'rizePatterns'].meeting,
				borderWidth: 12,
				pointRadius: 0
			}
		]
	}

	rizeDataPoints(type: RizeSessionType, records: Session[], xVal?: Date, yVal = false) {

		return records.filter(record => record.type === type).map(record => ([
			{
				x: NaN,
				y: NaN
			},
			{
				x: xVal ? this.equaliseX(record.startTime, xVal) : record.startTime.getTime(),
				y: yVal ? this.equaliseY(record.startTime) : 2.5
			},
			{
				x: xVal ? this.equaliseX(record.endTime, xVal) : record.endTime.getTime(),
				y: yVal ? this.equaliseY(record.endTime) : 2.5
			},
			{
				x: NaN,
				y: NaN
			}
		])).flat()
	}

	crudDatasets(types: CrudRecordType[] = CrudRecordTypes) {
		return [
			...types.map(type => ({
				...this.svcChartProps.crudPointStylesDetail[type],
				data: []
			}))
		]
	}

	hkitDatasets(types: HkitRecordLogType[] = HkitRecordLogTypes, yAxisID?: string) {

		return [
			...types.map(type => ({
				...this.svcChartProps.hkitPointStylesDetail[type],
				data: [],
				yAxisID
			}))
		]
	}

	equaliseX = (d: Date, x: Date): number => {
		const dDateTime = DateTime.fromJSDate(d);
		const xDateTime = DateTime.fromJSDate(x);
		return dDateTime.set({
								 year : xDateTime.year,
								 month: xDateTime.month,
								 day  : xDateTime.day
							 }).toMillis();
	};
	equaliseY = (d: Date): number => {
		const dDateTime = DateTime.fromJSDate(d).startOf('day');
		return dDateTime.toMillis();
	};
}
